(function () {
  function init(root) {
    var backdrop = root;
    var panel = root.querySelector('.bff-popup__panel');
    var formWrap = root.querySelector('[data-popup-form-wrap]');
    var success = root.querySelector('[data-popup-success]');
    var form = root.querySelector('[data-popup-form]');
    var closeButtons = root.querySelectorAll('[data-popup-close]');
    var storageKey = root.getAttribute('data-popup-storage-key') || 'bff-popup';
    var frequencyDays = parseInt(root.getAttribute('data-popup-frequency'), 10) || 14;
    var delaySeconds = parseInt(root.getAttribute('data-popup-delay'), 10) || 6;

    var lastFocus = null;

    function shouldShow() {
      try {
        var raw = localStorage.getItem(storageKey);
        if (!raw) return true;
        var data = JSON.parse(raw);
        if (data.subscribed) return false;
        if (!data.dismissedAt) return true;
        var msSince = Date.now() - data.dismissedAt;
        return msSince > frequencyDays * 86400000;
      } catch (e) {
        return true;
      }
    }

    function record(state) {
      try {
        var existing = {};
        try { existing = JSON.parse(localStorage.getItem(storageKey) || '{}'); } catch (e) {}
        var merged = Object.assign(existing, state);
        localStorage.setItem(storageKey, JSON.stringify(merged));
      } catch (e) {}
    }

    function open() {
      if (!shouldShow()) return;
      lastFocus = document.activeElement;
      root.hidden = false;
      root.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('bff-popup-open');
      requestAnimationFrame(function () {
        root.classList.add('is-open');
      });
      var firstField = root.querySelector('input[type="email"]');
      if (firstField) {
        setTimeout(function () { firstField.focus(); }, 200);
      }
    }

    function close(opts) {
      opts = opts || {};
      root.classList.remove('is-open');
      setTimeout(function () {
        root.hidden = true;
        root.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('bff-popup-open');
        if (lastFocus && typeof lastFocus.focus === 'function') {
          try { lastFocus.focus(); } catch (e) {}
        }
      }, 250);
      if (!opts.subscribed) {
        record({ dismissedAt: Date.now() });
      }
    }

    closeButtons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (e.target === btn || btn.contains(e.target)) {
          close();
        }
      });
    });

    document.addEventListener('keydown', function (e) {
      if (!root.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
    });

    if (form) {
      form.addEventListener('submit', function () {
        record({ subscribed: true });
        if (formWrap) formWrap.style.display = 'none';
        if (success) success.hidden = false;
        setTimeout(function () { close({ subscribed: true }); }, 2200);
      });
    }

    if (window.location.search.indexOf('customer_posted=true') !== -1) {
      record({ subscribed: true });
      return;
    }

    if (delaySeconds === 0) {
      open();
    } else {
      setTimeout(open, delaySeconds * 1000);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-bff-popup]').forEach(init);
  });
})();
